import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { getCompanys } from "../../services/dataService";
import { data } from "jquery";
import Loading from "../../components/common/Loading";

export default function Company() {
  const UID = localStorage.getItem("userId");
  const [uFetch, setUfetch] = useState({
    UserId: UID,
  });
  const [addCompanyModal, setAddCompanyModal] = useState(false);
  const [editCompanyModal, setEditCompanyModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const openAddCompanyModal = () => {
    setAddCompanyModal(!addCompanyModal);
  };
  const openEditCompanyModal = (data) => {
    console.log("data",data);

    const CommonDataName= commonDatas.find((item)=>{
      if(item.Id == data?.CommonDataId){
        return item?.Name; 
      }
    })
    console.log("CommonDataName",CommonDataName);
    
    setEditCompanyModal(!editCompanyModal);
    setCompanyData({
      ...data,
      Profitcenter:CommonDataName?.Name,
      UserId: UID || '',
    });
  };

  

  const [companys, setCompanys] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [commonDatas, setCommonDatas] = useState([]);
  const [selectedCommonData, setSelectedCommonData] = useState('');

  const [companyData, setCompanyData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    Code: "",
    CommonDataId: "",
    UserId: UID,
  });

  useEffect(() => {
    console.log("companyData",companyData);
    
   }, [companyData])
  

  useEffect(() => {
    setLoading(true);
    fetchCompanys();
  }, []);

  useEffect(() => {
    if (companys && companys.length > 0) {
      const updatedData = companys.map((item, index) => ({
        SlNo:  index + 1,
        Name: item.Name || "",
        Narration: item.Narration || "",
        Code: item.Code || "",
        CommonDataId: item.CommonDataId || "",
        UserId: item.UserId || "",
        Address: item.Address || "",
        GSTIN:item.GSTIN||'',
        PAN:item.PAN||''
      }));
      setDataFilter(updatedData);
    }
  }, [companys]);

  const fetchCompanys = async () => {
    try {
      const data = await getCompanys(UID);
      console.log(data.data.data, "Fetched data");
      setCompanys(data.data.data);
    } catch (error) {
      console.error("Error fetching companys", error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompanyData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleChanges = (event) => {
    setSelectedCommonData(event.target.value);
  };

// remove
  // const removeCompany = (companyId) =>{
  //   const removeData=
  //     { Id:companyId,
  //       TableName:"Companys"
  //     }
    
  //   try {
  //     const res = deleteCompanys(removeData,UID)
  //   } catch (error) {
      
  //   }
  //   fetchCompanys()
  // }  
// 
  const columnsFilter = [
    {
      name: "Sl No",
      selector: (row) => row.SlNo,
      sortable: true,
      grow: 0,
      width: "80px",
    },
    {
      name: "Company Name",
      selector: (row) => row.Name,
      sortable: true,
      grow: 0,
      width: "200px",
    },
    
    {
      name: "Company Narration",
      selector: (row) => row.Narration,
      sortable: true,
      grow: 0,
      width: "320px",
    },
    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
      grow: 0,
      width: "120px",
    },
    {
      name: "GSTIN",
      selector: (row) => row.GSTIN,
      sortable: true,
      grow: 0,
      width: "220px",
    },
    {
      name: "PAN",
      selector: (row) => row.PAN,
      sortable: true,
      grow: 0,
      width: "220px",
    },
    {
      name: "Address",
      selector: (row) => row.Address,
      sortable: true,
    },
    // {
    //   name: "Action",
    //   selector: (row) => (
    //     <div className="flex items-stretch gap-10">
    //       <button
    //         className="bg-sky rounded-[4px] px-10 py-[8px]"
    //         onClick={() => openEditCompanyModal(row)}
    //       >
    //         <IconEdit className="text-white w-[18px] h-[18px]" />
    //       </button>
    //       <button className="bg-danger rounded-[4px] px-10 py-[8px]"
    //         onClick={()=> removeCompany(row.Id)}  
    //       >
    //         <IconTrash className="text-white w-[18px] h-[18px]" />
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const filteredItems = dataFilter.filter(
    (item) =>
      // item.Id.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Name.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Code?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.Narration?.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

  
  }, [filterText, resetPaginationToggle]);



  
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };


  return (
    <>
    <div>
       <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Company"/>
        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search here..."
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <ReactDataTable
              columns={columnsFilter}
              data={filteredItems}
              pagination
              paginationResetDefaultPage={resetPaginationToggle}
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
            />
          )}
        </div>
      </div>
      {/* {addCompanyModal && (
        <>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Company
              </h5>
              <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                <div className="grid grid-cols-12 gap-20">
                  <div className="form-group flex col-span-12">
                  
                  </div>
                  <div className="form-group flex col-span-12">
                    <input
                      type="text"
                      id="name"
                      name="Name"
                      placeholder="Name"
                      value={companyData.Name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group flex col-span-12">
                    <input
                      type="text"
                      id="narration"
                      name="Narration"
                      placeholder="Narration"
                      value={companyData.Narration}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group flex col-span-12">
                    <input
                      type="text"
                      id="code"
                      name="Code"
                      placeholder="Code"
                      value={companyData.Code}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group flex col-span-12">
                    <select
                      name="CommonDataId"
                      value={companyData.CommonDataId}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Profit Center
                      </option>
                      {commonDatas.map((center) => (
                        <option key={center.Id} value={center.Id}>
                          {center.Name}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                
                
                </div>
              </div>
              <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                <button
                  onClick={openAddCompanyModal}
                  className="btn btn-outline-secondary"
                >
                  Cancel
                </button>
                <button onClick={handleSubmit} className="btn btn-primary">
                  Add
                </button>
              </div>
            </div>
          </div>
          <div
            onClick={openAddCompanyModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
      {editCompanyModal && (
        <>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Company
              </h5>
              <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                <div className="grid grid-cols-12 gap-20">
                  <div className="form-group flex col-span-12">
                  
                  </div>
                  <div className="form-group flex col-span-12">
                    <input
                      type="text"
                      id="Name"
                      name="Name"
                      placeholder="Name"
                      value={companyData.Name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group flex col-span-12">
                    <input
                      type="text"
                      id="Narration"
                      name="Narration"
                      placeholder="Narration"
                      value={companyData.Narration}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group flex col-span-12">
                    <input
                      type="text"
                      id="Code"
                      name="Code"
                      placeholder="Code"
                      value={companyData.Code}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group flex col-span-12">
                    <select
                      name="CommonDataId"
                      value={companyData.CommonDataId}
                      onChange={handleChange}
                    >
                     <option key="" value="">
                         {companyData.CommonDataId}
                        </option>
                      {commonDatas.map((data) => (
                        <option key={data.Id} value={data.Id}>
                          {data.Name}
                        </option>
                      ))}
                    </select>
                  </div>
                  
               
                </div>
              </div>
              <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                <button
                  onClick={openEditCompanyModal}
                  className="btn btn-outline-secondary"
                >
                  Cancel
                </button>
                <button onClick={handleEdit} className="btn btn-primary">
                  Edit
                </button>
              </div>
            </div>
          </div>
          <div
            onClick={openAddCompanyModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )} */}
    </>
  );
}
